import * as React from "react";
const ShadowXIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44 44"
    fill="none"
    {...props}
  >
    <g filter="url(#Xshadow)" className="shadow-lg">
      <path
        className=""
        fill="#fff"
        d="M27.296 15.293a1.001 1.001 0 0 1 1.416 1.416l-5.294 5.29 5.29 5.294a1.002 1.002 0 0 1-1.415 1.416l-5.29-5.294-5.294 5.29a1.002 1.002 0 0 1-1.416-1.415L20.587 22l-5.29-5.294a.998.998 0 0 1 0-1.413c.39-.39 1.024-.39 1.415 0l5.29 5.29 5.294-5.29Z"
      />
    </g>
    <defs>
      <filter
        id="Xshadow"
        width={24.005}
        height={24.002}
        x={10}
        y={12}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4_439"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4_439"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default ShadowXIcon;
